import React, { useEffect, useState } from "react";
import { createContext, useReducer } from "react";
import Reducer from "./Reducer";
import { handleClickToCall } from "./utils/util";
const initialState = {
  renvoidirect: false,
  renvoiinterne: false,
  renvoiexterne: false,
  msgvocaux: 0,
  socket: null,
  cmkPhone: {},
  userInfo: null,
  makeCall: {
    type: "",
    nom: "",
    image: "",
    number: "",
  },
  isCalling: false,
};

export const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  //
  const [isProcessingClickToCall, setIsProcessingClickToCall] = useState(false);
  //

  const isWebRtc = localStorage.getItem("isWEB") === "WEBRTC";
  useEffect(() => {
    if (!isWebRtc) {
      if (!isProcessingClickToCall && state?.makeCall?.number) {
        setIsProcessingClickToCall(true);
        handleClickToCall(state?.makeCall?.number, setIsProcessingClickToCall);
      }
      dispatch({
        type: "MAKE_CALL",
        payload: {
          nom: "",
          image: "",
          type: "",
          number: "",
        },
      });
    }
  }, [state?.makeCall?.number]);
  //
  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);

const getInitialTheme = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    const storedPrefs = window.localStorage.getItem("color-theme");
    if (typeof storedPrefs === "string") {
      return storedPrefs;
    }
    const userMedia = window.matchMedia("(prefers-color-scheme: dark)");
    if (userMedia.matches) {
      return "dark";
    }
  }
  // If you want to use dark theme as the default, return 'dark' instead
  return "light";
};
export const ThemeContext = React.createContext();
export const ThemeProvider = ({ initialTheme, children }) => {
  const [theme, setTheme] = React.useState(getInitialTheme);
  const rawSetTheme = (rawTheme) => {
    const root = window.document.documentElement;
    const isDark = rawTheme === "dark";
    root.classList.remove(isDark ? "light" : "dark");
    root.classList.add(rawTheme);
    localStorage.setItem("color-theme", rawTheme);
  };
  if (initialTheme) {
    rawSetTheme(initialTheme);
  }
  React.useEffect(() => {
    rawSetTheme(theme);
  }, [theme]);
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
